import { render } from "./ProjectBox.vue?vue&type=template&id=bf1b426e&scoped=true&ts=true"
import script from "./ProjectBox.vue?vue&type=script&lang=ts"
export * from "./ProjectBox.vue?vue&type=script&lang=ts"

import "./ProjectBox.vue?vue&type=style&index=0&id=bf1b426e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf1b426e"]])

export default __exports__